// removed by extract-text-webpack-plugin
module.exports = {"imprint":"styles__imprint__2EmtR","container":"styles__container__3LpER","homeLink":"styles__homeLink__116GV"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Imprint/styles.less
// module id = 379
// module chunks = 0